import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template-folder-list-skeleton',
  templateUrl: './template-folder-list-skeleton.component.html',
  styleUrls: ['./template-folder-list-skeleton.component.scss'],
  standalone: false
})
export class TemplateFolderListSkeletonComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
